import { EDIT_WEBHOOK_URL_SUCCESS, EDIT_WEBHOOK_URL_ERROR, EDIT_WEBHOOK_URL_LOADING } from '../Reducer/EditWebhookUrlReducer';


import { ApiEditWebhookUrl } from '../Api';

export function EditWebHookUrlThunk({ webhookUrl }) {
    return (dispatch, getState) => {
        dispatch({
            type: EDIT_WEBHOOK_URL_LOADING
        })
        ApiEditWebhookUrl(webhookUrl)
            .then((result) => {
                dispatch({
                    type: EDIT_WEBHOOK_URL_SUCCESS
                })
            })
            .catch((error) => {
                dispatch({
                    type: EDIT_WEBHOOK_URL_ERROR,
                    payload: {
                        error: error?.response?.data?.error?.message,
                    }
                })
            })
    }
}